<script setup lang="ts">
import type { Selectable } from '@/components/selectBox/selectBox';

import Dialog from '@/components/dialog/Dialog.vue';
import FormRows from '@/components/formRows/FormRows.vue';
import FormListboxInput from '@/components/formListboxInput/FormListboxInput.vue';
import FormTextInput from '@/components/formTextInput/FormTextInput.vue';

export type CreateAccountTwoFactorChannelProps = {
  channelTypes: App.Base.Data.EnumData[];
};

const props = defineProps<CreateAccountTwoFactorChannelProps>();

const { show, close } = useDialog();

const form = useForm({
  method: 'POST',
  url: route('account.two-factor.store'),
  fields: {
    type: props.channelTypes?.[0],
    destination: ''
  },
  transform: (fields) => ({
    ...fields,
    type: fields.type?.value
  })
});

const isSms = computed(() => form.fields.type.value === 'sms');

function handleTypeChange(value: Selectable<string> | null) {
  form.fields.type = value as Selectable<string>;
  form.fields.destination = '';
}
</script>

<template>
  <Dialog
    title="Add two factor authentication channel"
    confirmButtonLabel="Add channel"
    :isOpen="show"
    @onClose="close"
    @onCancel="close"
    @onConfirm="form.submit"
  >
    <FormRows>
      <FormListboxInput
        label="Device type"
        name="type"
        :options="channelTypes ?? []"
        :error="form.errors.type as string"
        :modelValue="form.fields.type"
        @update:modelValue="handleTypeChange"
      />
      <FormTextInput
        required
        :label="isSms ? 'Phone number' : 'Email address'"
        :placeholder="
          isSms
            ? 'Enter your phone number'
            : 'Enter your email address (not your GRACE email address)'
        "
        name="destination"
        :type="isSms ? 'tel' : 'email'"
        :error="form.errors.destination"
        :modelValue="form.fields.destination"
        @update:modelValue="(value) => (form.fields.destination = value as string)"
      />
    </FormRows>
  </Dialog>
</template>
